import React, { PropsWithChildren } from "react";

import css from "./section.module.scss";

export const Section = ({ children }: PropsWithChildren): JSX.Element => (
  <>
    <hr className={css.separator} />
    {children}
  </>
);
